<template>“<slot />”</template>
